import { html, css, LitElement } from 'lit'
import NavNode from './nav-node.js'
import './right-item/default.js'
import './right-item/model-range.js'
import './right-item/automation.js'
import './right-item/machining-center.js'
import './button.js'

import styleUrl from '../../css/styles.css?url'

window.customElements.define(
    'hedelius-right-column',
    class HedeliusRightColumn extends LitElement {
        static properties = {
            activeNode: { type: NavNode },
        }

        static styles = css`
            :host {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                overflow-y: auto;
                -ms-overflow-style: none;
                scrollbar-width: none;
            }
        `

        constructor() {
            super()
            this.activeNode = null
        }

        _handleClick(e, item) {
            if (item.children && item.children.length > 0) {
                e.preventDefault()
            }

            const customEvent = new CustomEvent('hedelius-column-click', {
                bubbles: true,
                composed: true,
                detail: { item },
            })
            this.dispatchEvent(customEvent)
        }

        buttonIcon() {
            return html`
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon-stroke h-7 min-h-7 w-7 min-w-7"
                    fill="none"
                    stroke="currentColor"
                    x="0px"
                    y="0px"
                    viewBox="0 0 30 30"
                >
                    <polyline points="12.65,8.16 19.62,15.14 12.92,21.84 " />
                    <circle cx="15" cy="15" r="14" />
                </svg>
            `
        }

        renderChild(child) {
            switch (child.entry_type) {
                case 'model_range':
                    return html`
                        <hedelius-right-item-model-range
                            .node=${child}
                        ></hedelius-right-item-model-range>
                    `
                case 'automation':
                    return html`
                        <hedelius-right-item-automation
                            .node=${child}
                        ></hedelius-right-item-automation>
                    `
                case 'machining_center':
                    return html`
                        <hedelius-right-item-machining-center
                            .node=${child}
                        ></hedelius-right-item-machining-center>
                    `
                default:
                    return html`
                        <hedelius-right-item-default .node=${child}></hedelius-right-item-default>
                    `
            }
        }

        render() {
            return html`
                <link rel="stylesheet" href="${styleUrl}" />

                <ul class="plus-list pt-[65px] max-md:px-hdls-xs md:pl-10 md:pr-hdls-xs">
                    <div
                        class="mb-8 flex h-16 items-center gap-4 text-2xl font-semibold leading-none md:text-3xl"
                    >
                        <button
                            @click="${(e) => this._handleClick(e, this.activeNode.parent)}"
                            class="-mr-2 md:hidden"
                        >
                            <svg
                                class="h-5 w-5"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2px"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 12.74 22.24"
                            >
                                <polyline class="cls-1" points="12.03 21.54 1.41 10.92 11.62 .71" />
                            </svg>
                        </button>
                        <span>${this.activeNode.title}</span>
                        <span class="text-lg font-light max-md:hidden"
                            >${this.activeNode.subtitle}</span
                        >
                    </div>
                    <div class="flex gap-3 max-md:flex-col">
                        ${this.activeNode.button_title &&
                        this.activeNode.href &&
                        html`
                            <hedelius-button
                                class="red-bold md:max-w-[355px]"
                                href=${this.activeNode.href}
                                .icon="${this.buttonIcon()}"
                            >
                                ${this.activeNode.button_title}
                            </hedelius-button>
                        `}
                        ${this.activeNode.second_button_title &&
                        this.activeNode.second_button_href &&
                        html`
                            <hedelius-button
                                class="light md:max-w-[355px]"
                                href=${this.activeNode.second_button_href}
                                .icon="${this.buttonIcon()}"
                            >
                                ${this.activeNode.second_button_title}
                            </hedelius-button>
                        `}
                    </div>
                    ${this.activeNode.children.map((child) => this.renderChild(child))}
                </ul>
            `
        }
    }
)
